export const calculateListPosition = (listRef, selectContainerRect) => {
  const styles = {}
  const listWidth = listRef.current.clientWidth
  const diffWrapperTop = selectContainerRect.top + listRef.current.clientHeight - window.innerHeight
  const left =
    selectContainerRect.left + listWidth > window.innerWidth
      ? selectContainerRect.right - listWidth
      : selectContainerRect.left
  if (diffWrapperTop > 0) {
    styles.top = `${selectContainerRect.top + window.scrollY - diffWrapperTop - 16}px`
  } else {
    styles.top = `${selectContainerRect.top + window.scrollY}px`
  }

  return { ...styles, left }
}
